<template>
    <div>
        <b-table
            id="cdas"
            :items="resultado"
            :fields="fields"
            striped
            small
            responsive="sm"
            tbody-tr-class="rowClass"
            :no-local-sorting="true"
            @sort-changed="sortingChanged"
            @show="show"
            @hide="hide"
            :busy="configTable.load"
            show-empty

            >
            <div slot="table-busy" class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Carregando...</strong>
            </div>

            <template slot="empty">
                <p class="my-auto">Nenhuma dívida com erro encontrada.</p>
            </template>

            <template slot="HEAD_selecionar">
                <b-form-checkbox v-model="configTable.checkedAll" class="mx-auto justify-content-center text-center ml-1" @change="toggleAll" />
            </template>
            <template slot="selecionar" slot-scope="row">
                <template v-if="!row.item.idPai">
                    <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="row.item.checked" @change="toggleCheck($event, row.item, null, false)" />
                </template>
            </template>
            <template slot="1" slot-scope="row">
                <b-link @click="abrirModalExtratoCda(row.item.codCdaSefa)" class="m-0 p-0 text-center">
                    <p class="m-0 p-0"> {{ row.item.numeroDivida }} </p>
                </b-link>
            </template>
            <template slot="2" slot-scope="row">
                <p class="m-0 p-0" v-for="divida in row.item.dividas" :key="divida.id">
                    {{ divida.contribuinte }}
               </p>
            </template>
            <template slot="3" slot-scope="row">
                <p class="m-0 p-0" v-for="divida in row.item.dividas" :key="divida.id">
                    {{ divida.cpfCnpj | cpfCnpj }}
               </p>
            </template>
            <template slot="4" slot-scope="row">
                <p class="m-0 p-0">
                    {{ row.item.tipoCredito }}
                </p>
            </template>
            <template slot="5" slot-scope="row">
                 <p class="m-0 p-0">
                    {{ row.item.comarca }}
                 </p>
            </template>
            <template slot="6" slot-scope="row">
                <p class="m-0 p-0">
                    {{ row.item.dtInscricao }}
                </p>
            </template>
            <template slot="7" slot-scope="row">
                 <p class="m-0 p-0" v-for="divida in row.item.dividas" :key="divida.id">
                    {{ divida.cadicms }}
                 </p>
            </template>
            <template slot="8" slot-scope="row">
                 <p class="m-0 p-0">
                    {{ row.item.valor | currency }}
                 </p>
            </template>
            <template slot="9" slot-scope="row">
                 <p class="m-0 p-0">
                    {{ row.item.erro }}
                 </p>
            </template>
            <template slot="10" slot-scope="row">
                 <p class="m-0 p-0 text-center">
                    <i @click.prevent="show(row.item)" class="fa fa-address-book fa-2x teste" style="color: #339af0;"></i>
                 </p>
            </template>
        </b-table>

        <ExtratoCda
            ref="extratoCda"
            @closeModal="closeModal" />
    </div>
</template>

<script>
import ExtratoCda from "../../shared/components/ExtratoCda";
export default {
    components: {ExtratoCda},
    props: ['resultado', 'fields', 'configTable', 'selecteds'],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false
            this.$emit('consultarDividas')
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage
        },
    },
    methods: {
        show (teste) {
           this.$emit('show', teste)
        },
        hide () {
            this.$emit('hide')
        },
        rowClass(item) {
            if (!item) return
            if (item.idPai) return 'table-sub-item'
        },
        toggleAll(checked) {
            if(checked) {
                this.resultado.forEach(el => {
                    el.checked = true;
                    this.selecteds.push(el)
                })
            } else {
                this.resultado.forEach(el => {
                    const index = this.selecteds.indexOf(el)
                    this.selecteds.splice(index, 1)
                    el.checked = false;
                })
            }
        },
        toggleCheck(checked, item, divida, all) {
            if(checked) {
                item.checked = checked
                this.selecteds.push(item)

                if(all) {
                    item.checkedAll = true
                    this.resultado.forEach(el => {
                        if (el.idPai == item.id) {
                            el.checked = true
                        }
                    })
                }
            } else {
            item.checked = false
            this.configTable.checkedAll = false
            const index = this.selecteds.indexOf(item)
            this.selecteds.splice(index, 1)

            if(all) {
                item.checkedAll = false
                this.resultado.forEach(el => {
                    if (el.idPai == item.id) {
                        el.checked = false
                        const index = this.selecteds.indexOf(el)
                        this.selecteds.splice(index, 1)
                    }
                })
            }
            }
        },
        sortingChanged(ctx) {
            if(ctx.sortBy == 1) {
                this.configTable.sortField = 'numeroDivida'
            }
            if(ctx.sortBy == 2) {
                this.configTable.sortField = 'contribuinte'
            }
            if(ctx.sortBy == 3) {
                this.configTable.sortField = 'cpfCnpj'
            }
            if(ctx.sortBy == 4) {
                this.configTable.sortField = 'tipoCredito'
            }
            if(ctx.sortBy == 5) {
                this.configTable.sortField = 'comarca'
            }
            if(ctx.sortBy == 6) {
                this.configTable.sortField = 'dtInscricao'
            }
            if(ctx.sortBy == 7) {
                this.configTable.sortField = 'cadicms'
            }
            if(ctx.sortBy == 8) {
                this.configTable.sortField = 'valorTotal'
            }
            if(ctx.sortBy == 9) {
                this.configTable.sortField = 'erro'
            }
            this.configTable.sortOrder = ctx.sortDesc ? 'desc' : 'asc'
            this.$emit('sortingChanged')
        },
        abrirModalExtratoCda(codCdaSefa) {
            this.$refs['extratoCda'].abrirExtrato(codCdaSefa);
        },
        closeModal() {
            this.$refs['extratoCda'].fecharModais();
        },
    }

}
</script>

<style>
.teste{
      text-align: center !important;
}
</style>
